import React, { useState, useEffect, useContext } from "react";
import {
  Box, Button, Flex,
  Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton,
  useDisclosure,
  Input
} from "@chakra-ui/react";
import { PanViewer } from "react-image-pan-zoom-rotate";
import { AppContext } from "AppProvider/AppContext";
import { appRequest } from "routes";
import { MdCloudUpload } from "react-icons/md";

type ReactPanZoomProps = {
  image: any;
  alt?: string;
  ref?: any;
  type?: string;
};

export const ReactPanZoom = ({ image, alt, type, ref }: ReactPanZoomProps) => {
  const [dx, setDx] = React.useState(0);
  const [dy, setDy] = React.useState(0);
  const [zoom, setZoom] = React.useState(1);
  const [rotation, setRotation] = React.useState(0);
  const [flip, setFlip] = React.useState(false);

  const resetAll = () => {
    setDx(0);
    setDy(0);
    setZoom(1);
    setRotation(0);
    setFlip(false);
  };
  const zoomIn = () => {
    setZoom(zoom + 0.2);
  };

  const zoomOut = () => {
    if (zoom > 0.3) {
      setZoom(zoom - 0.2);
    }
  };

  const rotateLeft = () => {
    if (rotation === -3) {
      setRotation(0);
    } else {
      setRotation(rotation - 1);
    }
  };

  const onPan = (dx: number, dy: number) => {
    setDx(dx);
    setDy(dy);
  };

  return (
    <div>
      <div
        style={{
          position: "absolute",
          right: "10px",
          zIndex: 2,
          top: 10,
          userSelect: "none",
          borderRadius: 2,
          background: "#fff",
          boxShadow: "0px 2px 6px rgba(53, 67, 93, 0.32)",
        }}
      >
        <div
          onClick={zoomIn}
          style={{
            textAlign: "center",
            cursor: "pointer",
            height: 40,
            width: 40,
            borderBottom: " 1px solid #ccc",
          }}
        >
          <svg
            style={{
              height: "100%",
              width: "100%",
              padding: 10,
              boxSizing: "border-box",
            }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 12H20"
              stroke="#4C68C1"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M12 4L12 20"
              stroke="#4C68C1"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <div
          onClick={zoomOut}
          style={{
            textAlign: "center",
            cursor: "pointer",
            height: 40,
            width: 40,
            borderBottom: " 1px solid #ccc",
          }}
        >
          <svg
            style={{
              height: "100%",
              width: "100%",
              padding: 10,
              boxSizing: "border-box",
            }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 12H20"
              stroke="#4C68C1"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <div
          onClick={rotateLeft}
          style={{
            textAlign: "center",
            cursor: "pointer",
            height: 40,
            width: 40,
            borderBottom: " 1px solid #ccc",
          }}
        >
          <svg
            style={{
              height: "100%",
              width: "100%",
              padding: 10,
              boxSizing: "border-box",
            }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 15L9 20L4 15"
              stroke="#4C68C1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20 4H13C10.7909 4 9 5.79086 9 8V20"
              stroke="#4C68C1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div
          onClick={resetAll}
          style={{
            textAlign: "center",
            cursor: "pointer",
            height: 40,
            width: 40,
          }}
        >
          <svg
            style={{
              height: "100%",
              width: "100%",
              padding: 10,
              boxSizing: "border-box",
            }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            stroke="#4C68C1"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
          </svg>
        </div>
      </div>
      <PanViewer
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1,
        }}
        zoom={zoom}
        setZoom={setZoom}
        pandx={dx}
        pandy={dy}
        onPan={onPan}
        rotation={rotation}
        key={dx}
      >
        <img
          style={{
            transform: `rotate(${rotation * 90}deg) scaleX(${flip ? -1 : 1})`,
            width: "100%",
          }}
          src={image}
          alt={alt}
          ref={ref}
        />
      </PanViewer>
    </div>
  );
};

export type Sample = {
  file: File | null;
  type: string | null;
  url: string;
  buffer: Uint8Array | null;
  name?: any;
  base64?: string | null;
};

export default function FileViewer({ sample, docId, recallApi, activePage }: { sample: Sample, name?: any, docId?: any, recallApi?: any, activePage?: any }) {
  const [fileType, setFileType] = useState<string>("pdf");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { toastNotify, accountDetails, workflowProcess } = useContext(AppContext);
  const [reUploadFile, setReUploadFile] = useState<File | null>(null);
  const [uploadLoading, setUploadLoading] = useState(false);

  const handleSaveReUpload = async () => {
    if (!reUploadFile || !docId) {
      toastNotify({
        title: "Error",
        message: "Please select a file to re-upload",
        type: "error",
      });
      return;
    }

    try {
      setUploadLoading(true);

      const reader = new FileReader();
      const base64Promise = new Promise<string>((resolve, reject) => {
        reader.onload = () => {
          const res = reader.result as string;
          resolve(res.split(",")[1]);
        };
        reader.onerror = (error) => reject(error);
      });
      reader.readAsDataURL(reUploadFile);
      const base64 = await base64Promise;

      const response: any = await appRequest("document", "replaceDocumentFile", {
        id: docId,
        file: base64,
        name: reUploadFile.name || "re_upload.pdf",
        type: reUploadFile.type || "application/pdf",
      });

      if (response?.status === "success") {
        if (recallApi && response?.newFileId) {
          recallApi(response?.newFileId)
        }
        toastNotify({
          title: "Success",
          message: "Invoice document re-uploaded successfully",
          type: "success",
        });
        setReUploadFile(null);
      } else {
        throw new Error(response?.data || response?.message || "Failed to save re-uploaded file");
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message || "An error occurred during re-upload",
        type: "error",
      });
    } finally {
      setUploadLoading(false);
    }
  };

  useEffect(() => {
    if (sample.url) {
      if (sample?.type === "pdf" || sample?.type === "application/pdf") {
        setFileType("pdf");
      } else if (sample?.type?.includes("image")) {
        setFileType("image");
      }
    }
  }, [sample]);

  const handleDownload = () => {
    if (!sample?.url) return;
    const link = document.createElement("a");
    link.href = sample.url;
    let downloadName = docId || sample?.name || "Document";

    if (!/\.[a-zA-Z0-9]+$/.test(downloadName)) {
      downloadName += fileType === "pdf" ? ".pdf" : ".png";
    }

    link.download = downloadName;
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
  };


  return (
    <Flex height="100%" flexDirection="column" width="100%">
      <Flex gap={2} mb={2}>
        <Button
          onClick={onOpen}
          colorScheme="teal"
          size="sm"
          flex={1}
        >
          View Full Size
        </Button>
        <Button
          onClick={handleDownload}
          colorScheme="blue"
          size="sm"
          flex={1}
        >
          Download
        </Button>
        {activePage === "Pending Approval" && accountDetails?.level === "level-1" && (workflowProcess?.processName === "foreign" || workflowProcess?.processName === "emerging") && (
          <Flex gap={2} flex={2} alignItems="center" bg="gray.100" p={1} borderRadius="md" border="1px dashed" borderColor="gray.300">
            <Button
              size="xs"
              colorScheme="gray"
              onClick={() => document.getElementById("re-upload-input")?.click()}
              leftIcon={<MdCloudUpload />}
              variant="outline"
              flex={1}
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              bg="white"
            >
              {reUploadFile ? reUploadFile.name : "Select New File"}
            </Button>
            <input
              id="re-upload-input"
              type="file"
              style={{ display: "none" }}
              onChange={(e) => setReUploadFile(e.target.files?.[0] || null)}
              accept="application/pdf,image/*"
            />
            <Button
              colorScheme="teal"
              size="xs"
              px={4}
              onClick={handleSaveReUpload}
              isLoading={uploadLoading}
              isDisabled={!reUploadFile}
              boxShadow="sm"
            >
              Save
            </Button>
          </Flex>
        )}
      </Flex>

      <Box flex="1" width="100%" height="100%" overflow="hidden">
        {fileType === "pdf" ? (
          <embed
            width="100%"
            height="100%"
            className="customScrollBar"
            src={sample?.url}
            type="application/pdf"
          ></embed>
        ) : (
          <Box position="relative" h="100%" w="100%" display="flex" flexDirection="column" overflow="hidden">
            <ReactPanZoom alt="uploaded image template" image={sample?.url} />
          </Box>
        )}
      </Box>

      {/* Drawer For Full Screen Viewing */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bg="white" maxW="90%">
          <DrawerCloseButton zIndex={10} />
          <DrawerHeader borderBottomWidth="1px">File Viewer</DrawerHeader>
          <DrawerBody p={0} display="flex" justifyContent="center" alignItems="center">
            {fileType === "pdf" ? (
              <embed src={sample?.url} width="100%" height="100%" type="application/pdf"></embed>
            ) : (
              <Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center">
                <ReactPanZoom alt="uploaded image template" image={sample?.url} />
              </Box>
            )}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
